import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';

export function EditAccountDialog({
  open,
  onClose,
  onSubmit,
  editAccountForm,
  setEditAccountForm,
  submitting,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Account</DialogTitle>
          <DialogDescription>Update business name, owner name, or email.</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label>Business / Brand Name</Label>
            <Input
              value={editAccountForm.brand_name}
              onChange={(e) => setEditAccountForm(p => ({ ...p, brand_name: e.target.value }))}
              placeholder="Business name"
              data-testid="edit-account-brand-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Owner Name</Label>
            <Input
              value={editAccountForm.owner_name}
              onChange={(e) => setEditAccountForm(p => ({ ...p, owner_name: e.target.value }))}
              placeholder="Full name"
              data-testid="edit-account-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Owner Email</Label>
            <Input
              type="email"
              value={editAccountForm.owner_email}
              onChange={(e) => setEditAccountForm(p => ({ ...p, owner_email: e.target.value }))}
              placeholder="email@example.com"
              data-testid="edit-account-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label>Owner Role</Label>
            <Select
              value={editAccountForm.owner_role || 'owner'}
              onValueChange={(value) => setEditAccountForm(p => ({ ...p, owner_role: value }))}
            >
              <SelectTrigger data-testid="edit-account-role-select">
                <SelectValue placeholder="Select role" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="owner">Owner</SelectItem>
                <SelectItem value="manager">Manager</SelectItem>
                <SelectItem value="staff">Staff</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={submitting} data-testid="edit-account-submit-btn">
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save Changes'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
